import React from "react";
import PropTypes from "prop-types";
import { Button, Card, Space, Typography } from "antd";
import { useExperiencesActions } from "hooks/useExperiencesActions";

const { Text } = Typography;

export const ActionsPanel = ({ trip, onEdit, routeType }) => {
  const {
    handleDelete,
    handleDeactivate,
    handleShare,
    modal
  } = useExperiencesActions();

  return (
    <Card style={{ borderRadius: 16, backgroundColor: "#F9FBFC", padding: "8px", boxShadow: "0 2px 8px #f0f1f2" }}>
      <Text strong style={{ marginBottom: 16, display: "block", fontSize: "18px" }}>Actions</Text>
      <Space direction="vertical" style={{ width: "100%" }} size={8}>
        <Button
          type="primary"
          block
          style={{ borderRadius: 36, height: "44px" }}
          onClick={onEdit}
        >
          Edit
        </Button>
        {routeType !== "deactivated" &&
          <>
            <Button
              block
              style={{ borderRadius: 36, height: "44px", borderColor: "#1D72F4", }}
              onClick={() => handleShare(trip)}
            >
              Share
            </Button>
            <Button
              block
              style={{ borderRadius: 36, height: "44px", borderColor: "#1D72F4", }}
              onClick={() => handleDeactivate(trip)}
            >
              Deactivate
            </Button>
          </>
        }
        <Button
          danger
          block
          style={{ borderRadius: 36, height: "44px", backgroundColor: "#F25330", color: "#ffffff" }}
          onClick={() => handleDelete(trip)}
        >
          Delete
        </Button>
      </Space>
      {modal}
    </Card>
  );
};

ActionsPanel.propTypes = {
  trip: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  routeType: PropTypes.string
};

export default ActionsPanel; 